import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { useLoginContext } from "../../../../context/loginContext";
import { utils } from "../../../../utils/globalVariables";

import TandaTerima from "./TandaTerima";
import tandaTerimaApi from "../api/tandaTerimaApi";

const TandaTerimaComponent = ({ stateDT }) => {

    const { loginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetDataInvoice: 'TandaTerimaComponent-1',
        dataInvoiceNoData: 'TandaTerimaComponent-2',
    })

    const [data, setData] = React.useState({
        devDataPDFProject: [],
        dataBarangKelengkapan: [],
        devDataPDFLoading: false,
        devDataCancelPDF: null,
    });

    React.useEffect(() => {
        // Membuat sumber pembatalan saat komponen dimuat
        const source = axios.CancelToken.source();
        setData(d => ({ ...d, devDataCancelPDF: source }))

        // Membersihkan sumber pembatalan saat komponen dilepas
        return () => {
            if (source) {
                source.cancel('Request canceled by user');
            }
        };
    }, []);

    // info : (jgn dihapus) Membersihkan sumber pembatalan saat pengguna pindah halaman
    // React.useEffect(() => {
    //     const cleanup = () => {
    //         if (data.devDataCancelPDF) {
    //             data.devDataCancelPDF.cancel('Request canceled by user');
    //         }
    //     };

    //     // Membersihkan sumber pembatalan saat pengguna pindah halaman
    //     return () => {
    //         cleanup();
    //     };
    // }, [history, data.devDataCancelPDF]);

    const fnSetDataForPDF = () => {
        setData(d => ({ ...d, devDataPDFLoading: true }));

        tandaTerimaApi.fetchData({
            stateData: {
                loginContextSyswebapp: loginContext.syswebapp,
                projectId: stateDT.projectId,
                projectStep: stateDT.projectStep,
                projectIsCancel: stateDT.projectIsCancel,
                cancelToken: data.devDataCancelPDF?.token,
            }
        })
            .then(data => {
                setData(d => ({ ...d, devDataPDFLoading: false }));

                if (data?.flag_status === 'no-data') {
                    notifications.show({
                        id: notificationId.current.errorGetDataInvoice,
                        title: utils.notification.warning.caption,
                        message: 'Data nota tidak ditemukan.',
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                } else {
                    if (Array.isArray(data.data) && (data.data.length > 0)) {
                        setData(d => ({
                            ...d,
                            devDataPDFProject: data.data,
                            dataBarangKelengkapan: data.barang_kelengkapan
                        }));
                    } else {
                        notifications.show({
                            id: notificationId.current.dataInvoiceNoData,
                            title: utils.notification.warning.caption,
                            message: 'Tidak Ada Data',
                            color: utils.notification.warning.color,
                            icon: utils.notification.warning.icon,
                            withBorder: true,
                            autoClose: true,
                        })
                    }
                }
            })
            .catch(error => {
                setData(d => ({ ...d, devDataPDFLoading: false }))

                if (axios.isCancel(error)) {
                    // konsol . log('Request canceled:', error.message);
                } else {
                    // konsol . log('Error fetching data:', error);
                }
            });
    }

    return (
        <React.Fragment>
            <TandaTerima
                stateDataProject={data.devDataPDFProject}
                stateCaption={stateDT.caption}

                stateProjectId={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].project_id : ''}

                stateCustomerName={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].customer_name : ''}

                stateCustomerContact={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? (data.devDataPDFProject[0].customer_contact ? data.devDataPDFProject[0].customer_contact : '') : ''}

                stateTanggalNota={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].tanggal_nota : ''}

                stateDP={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].biaya_dp : ''}
                stateDPMetode={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].biaya_dp_metode : ''}

                stateSign={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? (data.devDataPDFProject[0].customer_signature ? data.devDataPDFProject[0].customer_signature : null) : null}

                stateCustomerSignatureName={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].customer_signature_name : ''}

                stateBarangKelengkapan={data.dataBarangKelengkapan}

                stateLoading={data.devDataPDFLoading}
                fnSetIdleData={() => setData(d => ({ ...d, devDataPDFProject: [] }))}
                fnGetData={fnSetDataForPDF}
            />
        </React.Fragment>
    )
}

export default TandaTerimaComponent;